export default __webpack_public_path__ + "static/media/compleated.e154b32c.svg";